import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import Check from '@mui/icons-material/Check';
import { UseScreen } from '../../hooks/UseScreen.hook';

const ValidDate = () => {

  const screenWidth = UseScreen();

  return (
    <>
        <Grid item xs={ 12 } sx={{ justifyContent: 'center', textAlign: 'center' }}>
            <Grid container>
                <Grid item xs={12} sx={{ mb: 4 }}>
                    <Check sx={{ fontSize: '10rem', backgroundColor: 'primary.dark', borderRadius: '5rem' }} />
                </Grid>
                <Grid item xs={12}>
                    {
                        ( screenWidth > 500 ) ?
                        <h5 style={{ margin: '0' }}>Reserva editada exitosamente!</h5>
                        :
                        <h6 style={{ margin: '0' }}>Reserva editada exitosamente!</h6>
                    }
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default ValidDate